var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-shaped"},[_c('svg',{attrs:{"fill":"none","height":"22","viewBox":"0 0 20 22","width":"20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke":_vm.myColors.dLShape,"d":"M0.913086 20.9784H18.9131V0.978394"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }